/**
 * Cookie Consent Manager
 * GDPR-compliant cookie consent with localStorage persistence
 * 
 * Usage:
 * - Banner is shown if no consent decision has been made
 * - Consent is stored in localStorage as 'cookieConsent'
 * - Analytics scripts are only loaded after consent is given
 */

(function() {
  'use strict';

  const CONSENT_KEY = 'cookieConsent';
  const CONSENT_ACCEPTED = 'accepted';
  const CONSENT_REJECTED = 'rejected';

  /**
   * Get current consent status
   * @returns {string|null} 'accepted', 'rejected', or null if not set
   */
  function getConsent() {
    try {
      return localStorage.getItem(CONSENT_KEY);
    } catch (e) {
      // localStorage not available (private browsing, etc.)
      return null;
    }
  }

  /**
   * Set consent status
   * @param {string} status - 'accepted' or 'rejected'
   */
  function setConsent(status) {
    try {
      localStorage.setItem(CONSENT_KEY, status);
    } catch (e) {
      // localStorage not available
      console.warn('Could not save cookie consent preference');
    }
  }

  /**
   * Show the cookie consent banner
   */
  function showBanner() {
    const banner = document.getElementById('cookie-consent-banner');
    if (banner) {
      banner.style.display = 'block';
      // Add animation class after a small delay for CSS transition
      setTimeout(function() {
        banner.classList.add('cookie-consent-visible');
      }, 10);
    }
  }

  /**
   * Hide the cookie consent banner
   */
  function hideBanner() {
    const banner = document.getElementById('cookie-consent-banner');
    if (banner) {
      banner.classList.remove('cookie-consent-visible');
      setTimeout(function() {
        banner.style.display = 'none';
      }, 300); // Match CSS transition duration
    }
  }

  /**
   * Load analytics scripts (GA4, GTM)
   * Called only after user accepts cookies
   */
  function loadAnalytics() {
    // Check for GA4
    const gaId = window.DOUGLAS_GA_ID;
    if (gaId) {
      // Load gtag.js
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + gaId;
      document.head.appendChild(script);

      // Initialize gtag
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', gaId, { 'anonymize_ip': true });
    }

    // Check for GTM
    const gtmId = window.DOUGLAS_GTM_ID;
    if (gtmId) {
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer',gtmId);
    }

    // Dispatch custom event for other scripts that depend on consent
    window.dispatchEvent(new CustomEvent('cookieConsentAccepted'));
  }

  /**
   * Handle accept button click
   */
  function handleAccept() {
    setConsent(CONSENT_ACCEPTED);
    hideBanner();
    loadAnalytics();
  }

  /**
   * Handle reject button click
   */
  function handleReject() {
    setConsent(CONSENT_REJECTED);
    hideBanner();
    // Dispatch custom event
    window.dispatchEvent(new CustomEvent('cookieConsentRejected'));
  }

  /**
   * Initialize cookie consent
   */
  function init() {
    const consent = getConsent();
    
    if (consent === CONSENT_ACCEPTED) {
      // User has already accepted - load analytics
      loadAnalytics();
    } else if (consent === CONSENT_REJECTED) {
      // User has rejected - do nothing
    } else {
      // No decision made yet - show banner
      showBanner();
    }

    // Bind event handlers
    const acceptBtn = document.getElementById('cookie-accept');
    const rejectBtn = document.getElementById('cookie-reject');

    if (acceptBtn) {
      acceptBtn.addEventListener('click', handleAccept);
    }

    if (rejectBtn) {
      rejectBtn.addEventListener('click', handleReject);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose functions for external use
  window.CookieConsent = {
    getConsent: getConsent,
    setConsent: setConsent,
    showBanner: showBanner,
    hideBanner: hideBanner,
    reset: function() {
      try {
        localStorage.removeItem(CONSENT_KEY);
      } catch (e) {}
      showBanner();
    }
  };

})();

